import React from "react";
import PropTypes from "prop-types";

/**
 * Icono digital vectorial para convenios:
 * Documento con esquina superior derecha doblada, líneas de texto
 * y sello con palomita de firmado/aprobado en la esquina inferior derecha.
 * Estilo moderno y plano con degradado magenta guinda.
 */
const IconoConvenio = ({ className = "" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 84 96"
      className={`icono-convenio-svg ${className}`.trim()}
      aria-hidden="true"
      focusable="false"
    >
      <defs>
        <linearGradient id="convenioGrad" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#C9269F" />
          <stop offset="100%" stopColor="#9D1286" />
        </linearGradient>
      </defs>

      {/* Hoja principal con esquina doblada */}
      <path
        className="doc-sheet"
        d="M 18,6
           L 52,6
           L 68,22
           L 68,82
           C 68,86.4 64.4,90 60,90
           L 18,90
           C 13.6,90 10,86.4 10,82
           L 10,14
           C 10,9.6 13.6,6 18,6
           Z"
        fill="url(#convenioGrad)"
      />

      {/* Pliegue superior derecho */}
      <path
        className="doc-fold"
        d="M 52,6
           L 52,20
           C 52,22 54,22 56,22
           L 68,22
           Z"
        fill="#E861C5"
        opacity="0.9"
      />

      {/* Líneas de texto del convenio */}
      <line
        className="doc-line"
        x1="20"
        y1="34"
        x2="56"
        y2="34"
        stroke="#FFFFFF"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <line
        className="doc-line"
        x1="20"
        y1="44"
        x2="56"
        y2="44"
        stroke="#FFFFFF"
        strokeWidth="3.5"
        strokeLinecap="round"
      />
      <line
        className="doc-line"
        x1="20"
        y1="54"
        x2="40"
        y2="54"
        stroke="#FFFFFF"
        strokeWidth="3.5"
        strokeLinecap="round"
      />

      {/* Cintas decorativas del sello */}
      <path
        className="doc-seal-ribbon"
        d="M 53,82 L 49,94 L 56,90 L 63,94 L 59,82 Z"
        fill="#800A6B"
      />

      {/* Círculo del sello */}
      <circle
        className="doc-seal-circle"
        cx="56"
        cy="72"
        r="12"
        fill="#FFFFFF"
        stroke="#9D1286"
        strokeWidth="2"
      />

      {/* Palomita (check mark) de firmado / aprobado */}
      <polyline
        className="doc-seal-check"
        points="51,72 54.5,75.5 61.5,67.5"
        fill="none"
        stroke="#9D1286"
        strokeWidth="2.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

IconoConvenio.propTypes = {
  className: PropTypes.string,
};

export default IconoConvenio;
